import { render, staticRenderFns } from "./controlGoodsAction.vue?vue&type=template&id=09031263&scoped=true"
import script from "./controlGoodsAction.vue?vue&type=script&lang=js"
export * from "./controlGoodsAction.vue?vue&type=script&lang=js"
import style0 from "./controlGoodsAction.vue?vue&type=style&index=0&id=09031263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09031263",
  null
  
)

export default component.exports